import { Copy } from "lucide-react";
import React, { useRef } from "react";

const confirmationCopyButtonClasses = ["text-confirmation", "bg-confirmation/20", "border-transparent", "opacity-100"];

export function CopyableTextField(props: { value: string; displayValue?: string }) {
    const linkInputRef = useRef<HTMLInputElement>(null);
    const runConfirmCopyAnimation = () => {
        linkInputRef.current?.classList.add(...confirmationCopyButtonClasses);
        setTimeout(() => {
            linkInputRef.current?.classList.remove(...confirmationCopyButtonClasses);
        }, 1_000);
    };
    const copyUrl = () => {
        runConfirmCopyAnimation();
        void navigator.clipboard.writeText(props.value);
    };
    return (
        <div
            ref={linkInputRef}
            className={
                "relative overflow-hidden text-nowrap rounded-lg border-2 border-accent px-3 py-2 text-sm font-semibold transition-all"
            }
        >
            {props.displayValue ?? props.value}
            <div
                onClick={copyUrl}
                className={
                    "absolute bottom-0 right-0 top-0 flex cursor-pointer flex-col justify-center bg-gradient-to-r from-transparent to-background pe-3 ps-20 text-foreground"
                }
            >
                <Copy className={"h-5 w-5"} />
            </div>
        </div>
    );
}
